import { useCallback, useEffect, useRef } from 'react';
import { invokeAfterPaint } from '@splunk/dashboard-utils';

interface UseOnPaintCompleteOptions {
    once?: boolean;
}

const EmptyHookOptions: UseOnPaintCompleteOptions = {};

export const useOnPaintComplete = (
    callback: () => void,
    { once = false }: UseOnPaintCompleteOptions = EmptyHookOptions
) => {
    const hasInvokedCallback = useRef(false);
    const cleanupRef = useRef<() => void>();

    const invokeCallback = useCallback(() => {
        hasInvokedCallback.current = true;
        cleanupRef.current = undefined;
        callback();
    }, [callback]);

    if (!hasInvokedCallback.current || !once) {
        cleanupRef.current = invokeAfterPaint(invokeCallback);
    }

    useEffect(() => () => cleanupRef.current?.(), []);
};
